import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import CloseIcon from '../../themes/svg/closeIcon';

import locale from './locale';

function preventPropagation(e) {
  e.preventDefault();
  e.stopPropagation();
}

class CloseEstimate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
  }

  componentWillMount() {
    Modal.setAppElement('#estimateBuilderRoot');
  }

  onCloseClick = (e) => {
    this.closeModal();
    e.preventDefault();
  };

  attemptToClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (this.props.safeToClose) this.closeEstimate();
    else {
      this.setState({ modalIsOpen: true });
    }
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  closeEstimate = () => {
    this.props.closeEstimate(this.props.id, { disassociate: true });
    this.closeModal();
  };

  render() {
    return (
      <div className="action" onClick={preventPropagation} tabIndex="-1" role="button">
        <div className="close-estimate" onClick={this.attemptToClose} tabIndex="-1" role="button">
          <CloseIcon />
        </div>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          className="estimatebuilder-modal"
          overlayClassName="estimatebuilder-modal-overlay"
          style={{
            content: {
              width: 450,
            },
          }}
        >
          <div className="confirmCloseModal">
            <h2>{locale.header}</h2>

            <div className="modal-close" onClick={this.onCloseClick} tabIndex="-1" role="button">
              <CloseIcon />
            </div>
            <div className="modal-body">
              <p>
                {locale.content}
              </p>
              <button className="btn btn-primary" onClick={this.closeEstimate}>
                {locale.buttonText}
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

CloseEstimate.propTypes = {
  id: PropTypes.string.isRequired,
  closeEstimate: PropTypes.func.isRequired,
  safeToClose: PropTypes.bool,
};
CloseEstimate.defaultProps = {
  safeToClose: false,
};

export default CloseEstimate;
